import { Button, cn, Label } from "@devhop/ui";
import { Database, PenLine } from "lucide-react";

export type ServiceItemSource = "stock" | "manual";

type ServiceItemSourceSelectorProps = {
  value: ServiceItemSource;
  onChange: (source: ServiceItemSource) => void;
  disabled?: boolean;
};

export function ServiceItemSourceSelector({
  value,
  onChange,
  disabled,
}: ServiceItemSourceSelectorProps) {
  return (
    <div className="space-y-2">
      <Label>ແຫຼ່ງຂໍ້ມູນບໍລິການ</Label>
      <div className="flex flex-wrap gap-2">
        <Button
          type="button"
          variant={value === "stock" ? "default" : "outline"}
          size="sm"
          disabled={disabled}
          className={cn("gap-1.5")}
          onClick={() => onChange("stock")}
        >
          <Database className="size-3.5" />
          ດຶງຈາກ Stock POS
        </Button>
        <Button
          type="button"
          variant={value === "manual" ? "default" : "outline"}
          size="sm"
          disabled={disabled}
          className={cn("gap-1.5")}
          onClick={() => onChange("manual")}
        >
          <PenLine className="size-3.5" />
          ກຳນົດເອງ (CMS)
        </Button>
      </div>
      <p className="text-muted-foreground text-xs">
        Stock = ດຶງລາຄາ/spec/ຮູບ · CMS = ເນື້ອຫາ + ເຊື່ອມໜ້າ
      </p>
    </div>
  );
}
